import type { Box } from "./closed-frame-extent";

/**
 * Box of a closed-state element for sizing the iframe frame.
 *
 * The peek bubble and the auth-error popup spring in from `scale(0.88) translateY(18px)`.
 * `getBoundingClientRect()` reflects that transform, so measuring while they animate made the
 * frame creep up one rAF at a time (a dozen resizes over ~300ms) towards the final size.
 * Their LAYOUT box (`offset*`, transform free) is the rest position the animation ends at, so
 * the frame is sized once. The launcher button keeps its real rect: its hover scale is
 * covered by the shadow pad and it is not animated in.
 */
export function footprintBox(el: Element): Box {
  if (
    el instanceof HTMLElement &&
    (el.hasAttribute("data-wx-peek") || el.hasAttribute("data-wx-popup"))
  ) {
    return {
      left: el.offsetLeft,
      top: el.offsetTop,
      width: el.offsetWidth,
      height: el.offsetHeight,
    };
  }
  const r = el.getBoundingClientRect();
  return { left: r.left, top: r.top, width: r.width, height: r.height };
}
